import {
  BodyLinkV3,
  LayoutGrid,
  TypographyRhythm,
  TypographyV3,
} from '@jouzen/ecom-components';

import PageLayoutV3 from '@/app/components/PageLayoutV3';

const Page = (): JSX.Element => {
  return (
    <PageLayoutV3
      pageName="Terms and Conditions"
      containerProps={{
        name: 'terms-and-conditions',
        padding: 'both',
        lang: 'nb',
      }}
      footerProps={{
        wrapperClassName: 'bg-white',
      }}
    >
      <LayoutGrid data-cy="terms-and-conditions-nb-page">
        <TypographyRhythm className="col-main">
          <TypographyV3 Element="h1" variant="h1">
            ŌURAs VILKÅR FOR BRUK
          </TypographyV3>
          <BodyLinkV3 color="inherit" href="/nb/gen2-terms-and-conditions">
            Tidligere vilkår og betingelser
          </BodyLinkV3>
          <TypographyV3>
            <em>Sist oppdatert: 2. april 2024</em>
          </TypographyV3>
          <TypographyV3>
            Velkommen og takk for din interesse for Ōura! Disse vilkårene for
            bruk («avtalen») beskriver vilkårene og betingelsene som gjelder for
            din bruk av ouraring.com («nettstedet»), smartringen, laderen
            og/eller annet elektronisk utstyr («produktene»), inkludert
            Ōura-mobilapplikasjonen («mobilappen») (samlet kalt «tjenestene»).
            Nettstedet og mobilappen eies og drives av <b>Ōura Health Oy</b> og
            dets tilknyttede selskaper og datterselskaper, slik som Ouraring
            Inc. (samlet kalt «Ōura» eller «Oura»).
          </TypographyV3>
          <TypographyV3>
            I denne avtalen refererer vi til oss selv som «Ōura» eller «Oura»
            eller «oss» eller «vi», og vi refererer til deg som «du» eller
            «kunden». Oura og kunden omtales i denne avtalen hver for seg som en
            «part» og samlet som «partene».
          </TypographyV3>
          <TypographyV3>
            Ved å få tilgang til eller bruke tjenestene, inkludert tilgang til
            nettstedet, har du til hensikt og godtar du uttrykkelig å være
            bundet av alle vilkår og betingelser i denne avtalen og i
            personvernerklæringen (tilgjengelig på{' '}
            <BodyLinkV3 color="inherit" href="/nb/privacy-policy">
              ouraring.com/privacy-policy
            </BodyLinkV3>
            ), som er innlemmet ved referanse. Hvis du ikke godtar disse
            vilkårene, kan du ikke bruke tjenestene.
          </TypographyV3>
          <TypographyV3 Element="h2" variant="h3">
            Tilgang og bruk
          </TypographyV3>
          <TypographyV3>
            Oura gir deg en begrenset lisens til å få tilgang til nettstedet
            underlagt denne avtalen. Hvis du velger å abonnere på og bruke
            mobilappen, gir Oura deg videre en lisens til å få tilgang til og
            bruke tjenestene, underlagt og på betingelse av at du overholder
            denne avtalen, personvernerklæringen og alle andre regler og krav
            som er formidlet til deg av Oura, inkludert at du betaler eventuelle
            avgifter. Du erkjenner og godtar at Oura kan modifisere, oppdatere
            og på annen måte endre tjenestene når som helst og etter eget
            skjønn.
          </TypographyV3>
          <TypographyV3>
            Du erklærer og garanterer at du er minst 18 år og har juridisk
            myndighet til å godta denne avtalen på egne vegne eller på vegne av
            enhver part du representerer. Du alene er ansvarlig for aktivitetene
            dine og samhandlingen din med tjenestene.
          </TypographyV3>
          <TypographyV3>
            Du skal ikke bruke tjenestene til noen formål utover omfanget av
            tilgangen som er gitt i denne avtalen. Du skal ikke på noe
            tidspunkt, direkte eller indirekte, og skal heller ikke tillate noen
            tredjepart å: (i) kopiere, modifisere eller lage avledede verk av
            tjenestene, helt eller delvis, (ii) foreta omvendt utvikling,
            demontere, dekompilere, dekode, tilpasse eller på annen måte forsøke
            å utlede eller få tilgang til noen av mobilappkomponentene i
            tjenestene, helt eller delvis, eller (iii) bruke tjenestene på noen
            måte eller til noe formål som krenker, misbruker eller på annen måte
            bryter med en persons immaterielle rettigheter eller andre
            rettigheter (inkludert, men ikke begrenset til nettskraping), eller
            som på annen måte bryter med lover, forskrifter eller andre lovkrav.
          </TypographyV3>
          <TypographyV3>
            Kjøp er kun ment for deg som sluttbruker og er ikke godkjent for
            videresalg uten Ouras uttrykkelige tillatelse. Vi forbeholder oss
            retten til å avslå eller kansellere bestillingen hvis vi mistenker
            at du kjøper tjenester for videresalg.
          </TypographyV3>
          <TypographyV3>
            Med unntak av den begrensede lisensen til å få tilgang til
            nettstedet og mobilappen som angitt ovenfor, erkjenner du at
            ingenting i denne avtalen skal tolkes som tildeling eller
            overdraging, enten implisitt, ved innsigelse eller på annen måte, av
            noen rettighet til, eiendomsrett til eller interesse i ethvert
            åndsverk, inkludert (i) oppfinnelser (enten de er patenterbare eller
            ikke i et hvilket som helst land), patenter, patentsøknader,
            offentliggjøringer av oppfinnelser, forbedringer,
            forretningshemmeligheter, bedriftsintern informasjon, kunnskap,
            informasjon eller tekniske data, (ii) opphavsrettsbeskyttede verk,
            opphavsrettsregistreringer, maskeverk, maskeverkregistreringer eller
            søknader om dette i USA eller noe annet land, (iii) varemerker,
            varemerkeregistreringer, tjenestemerker, logoer eller søknader om
            dette i USA eller noe annet land, (iv) forretningshemmeligheter,
            eller (v) andre materielle eller immaterielle rettigheter hvor som
            helst i verden.
          </TypographyV3>
          <TypographyV3>
            Du erkjenner og godtar at tjenestene til tider kan være
            utilgjengelige eller ubrukelige uansett årsak, inkludert, men ikke
            begrenset til: (i) funksjonsfeil på utstyr; (ii) periodisk
            vedlikehold eller reparasjoner som Oura kan foreta fra tid til annen
            uten varsel til deg; eller (iii) årsaker som ligger utenfor Ouras
            kontroll eller som ikke med rimelighet kan forutses.
          </TypographyV3>
          <TypographyV3>
            Uavhengig av eventuelle motstridende bestemmelser i denne avtalen
            kan Oura av sikkerhetshensyn midlertidig oppheve tilgangen til
            tjenestene som tilbys deg og enhver annen tredjepart, for å
            forhindre ulovlig eller bedragersk aktivitet, for å etterkomme
            forespørsler fra ethvert juridisk eller statlig organ, eller hvis du
            bryter avtalen eller personvernerklæringen.
          </TypographyV3>
          <TypographyV3>
            Oura kan fra tid til annen og etter eget skjønn engasjere andre
            tjenesteleverandører som skal bistå i utførelsen av tjenestene, for
            eksempel webhotelleverandører, betalingsbehandlere og andre
            tredjeparter. Du skal overholde vilkårene for bruk og andre krav
            knyttet til tjenestene som leveres av slike tredjeparter i
            forbindelse med tjenestene.
          </TypographyV3>
          <TypographyV3 Element="h2" variant="h3">
            Kundens ansvar
          </TypographyV3>
          <TypographyV3>
            Du erkjenner at du ene og alene er ansvarlig for bruken din av
            tjenestene, direkte eller indirekte, herunder at du forstår om denne
            tilgangen eller bruken er tillatt av eller i strid med denne
            avtalen. Du har videre det fulle ansvar for at alle gjeldende lover
            knyttet til din bruk av tjenestene overholdes. Du skal bruke
            tjenestene utelukkende til lovlige formål og skal utføre all
            aktivitet gjennom tjenestene i samsvar med alle gjeldende lover og
            forskrifter, inkludert, men ikke begrenset til, alle gjeldende
            føderale og statlige lover og forskrifter som regulerer tilbud og
            salg av verdipapirer, hvitvasking av penger og terrorbekjempelse.
          </TypographyV3>
          <TypographyV3>
            Du alene er ansvarlig for å sikre og sørge for at du kan få tilgang
            til og bruke tjenestene, deriblant ved å sørge for å ha kompatibel
            maskinvare, mobilapp, internettilgang, sikkerhetsmobilapp,
            sikkerhetskopieringsutstyr eller -tjenester, og eventuelle andre
            krav. Oura har ikke noe ansvar for å levere noen ytterligere
            mobilapp eller maskinvare. Du samtykker videre i at Oura ikke skal
            ha noe ansvar for tap av data eller andre former for skade eller tap
            påført i forbindelse med bruken din av tjenestene, inkludert
            unnlatelse av å sørge for tilstrekkelig sikkerhet eller
            sikkerhetskopieringsutstyr eller -tjenester.
          </TypographyV3>
          <TypographyV3>
            Du er ansvarlig for å sikre at Oura har nøyaktig og oppdatert
            informasjon i kundekontoen din, inkludert oppdatert kontakt- og
            betalingsinformasjon. Du er videre ansvarlig for å sjekke den
            tilknyttede kunde-e-postkontoen regelmessig for å se om det har
            kommet e-post fra Oura.
          </TypographyV3>
          <TypographyV3>
            Hvis du har fått et brukernavn, et passord, en fil med
            påloggingsinformasjon eller annen informasjon som del av en
            sikkerhetsprosedyre («påloggingsinformasjon»), må du behandle denne
            informasjonen som konfidensiell, og du må ikke avsløre
            påloggingsinformasjonen til noen andre personer eller enheter. Du
            erkjenner at kontoen din og påloggingsinformasjonen bare er til deg
            personlig, og samtykker videre i ikke å gi noen annen person tilgang
            til tjenestene eller deler av tjenestene ved å bruke ditt brukernavn
            eller passord eller annen sikkerhetsinformasjon. Du skal varsle Oura
            umiddelbart om uautorisert tilgang til eller bruk
            påloggingsinformasjonen din eller andre sikkerhetsbrudd. Oura har
            rett til når som helst å deaktivere ethvert brukernavn, ethvert
            passord, enhver fil med påloggingsinformasjon eller annen
            identifikator, enten disse er valgt av deg eller gitt av Oura.
          </TypographyV3>
          <TypographyV3>
            Oura er innenfor rimelighetens grenser forpliktet til å tilby
            tilfredsstillende støttetjenester for tjenestene. Til tross for det
            foregående gir denne avtalen deg ikke rett til noen garantier med
            hensyn til nivå av, tilgjengelighet av eller responstid for
            støttetjenestene for tjenestene.
          </TypographyV3>
          <TypographyV3 Element="h2" variant="h3">
            Betaling og avgifter
          </TypographyV3>
          <TypographyV3>
            Betalte tjenester inkluderer tjenestene, som kan være engangskjøp
            eller automatisk fornyelse av abonnementstjenester («betalte
            tjenester»), inkludert nettstedet vårt og mobilappen
            («abonnementer»). Vi kan gjøre endringer i, sperre eller avvikle
            betalte tjenester når som helst av hvilken som helst årsak, og Oura
            forbeholder seg retten til etter eget skjønn å avgjøre hvilke
            tjenester eller deler av disse som krever betaling.
          </TypographyV3>
          <TypographyV3>
            Betalte tjenester kan omfatte forhåndsbestilte produkter som vil bli
            produsert for deg i fremtiden («forhåndsbestilling»). Du vil bli
            belastet en forhåndsbestillingsavgift når du legger inn
            forhåndsbestillingen. Den faktiske datoen for forsendelse av enhver
            akseptert forhåndsbestilling vil avhenge av en rekke faktorer,
            inkludert, men ikke begrenset til, datoen for betaling av
            forhåndsbestillingsavgiften og Ouras produksjonsplan. Det gis ingen
            garanti for forsendelsesdato for forhåndsbestillinger.
          </TypographyV3>
          <TypographyV3>
            Du godtar å betale alle gjeldende avgifter for betalte tjenester,
            inkludert, men ikke begrenset til, eventuelle månedlige
            abonnementsavgifter, brukerbetalinger, tilbudsavgifter og andre
            eventuelle avgifter, belastninger eller kostnader som du godtar å
            kjøpe som en del av de betalte tjenestene under betalingsprosessen
            («avgifter»). Du godtar å betale alle avgifter og alle gjeldende
            skatter som påløper før oppsigelse eller kansellering av avtalen.
          </TypographyV3>
          <TypographyV3>
            Du gir Oura fullmakt til å belaste din angitte betalingsmåte for
            betalte tjenester. Ved å oppgi en akseptabel betalingsmåte bekrefter
            og garanterer du at du har fullmakt til å bruke den angitte
            betalingsmåten, og at du gir oss eller vår tredjeparts
            betalingsbehandler fullmakt til å belaste betalingsmåten din for det
            totale kjøpsbeløpet, inkludert eventuelle gjeldende skatter og andre
            belastninger. Hvis betalingsmåten ikke kan verifiseres, er ugyldig
            eller på annen måte ikke er akseptabel, kan den betalte tjenesten
            din bli innstilt eller kansellert. Du må løse eventuelle problemer
            vi støter på i tilknytning til betalingsmåten du oppgir, for å
            fortsette bruken din av tjenesten. Hvis du godtar et kampanjetilbud
            eller gjør endringer i de betalte tjenestene dine, kan avgiftene,
            skattene og beløpene som faktureres, variere. Fakturabeløpene kan
            også variere på grunn av endringer i gjeldende skatter eller
            valutakurser. Du gir oss eller vår tredjeparts betalingsbehandler
            fullmakt til å belaste betalingsmåten din for det tilsvarende
            beløpet. Det vil ikke bli gitt refusjoner med mindre det er
            lovpålagt. Individuelle rabatter kan ikke kombineres med eller
            legges til andre rabatter. Denne betalingsforpliktelsen skal
            fortsatt gjelde etter oppsigelse eller kansellering av denne avtalen
            uansett årsak.
          </TypographyV3>
          <TypographyV3>
            Hvis du velger å finansiere et kjøp gjennom vår tredjeparts
            betalingsbehandler og en eller flere varer i bestillingen din har en
            utvidet forsendelsesdato, kan betalingen(e) på lånet, inkludert
            rente, forfalle før vi har sendt alle varene. Vær oppmerksom på at
            du kanskje ikke får fratrekk for eventuell rente som allerede har
            påløpt på et beløp som senere blir refundert.
          </TypographyV3>
          <TypographyV3 Element="h2" variant="h3">
            Abonnementer
          </TypographyV3>
          <TypographyV3>
            Enkelte betalte tjenester er abonnementsbaserte kjøp, der følgende
            vilkår gjelder:
          </TypographyV3>
          <TypographyV3>
            <b>
              Abonnementsperioden kan være en kontinuerlig, månedlig eller årlig
              periode («abonnementsperiode(r)»), som beskrevet når du kjøper de
              betalte tjenestene. Abonnementet ditt fornyes automatisk i
              ytterligere abonnementsperioder til du selv sier opp abonnementet,
              eller til det innstilles eller avsluttes av Oura. Med mindre annet
              er angitt av oss, vil din angitte betalingsmåte bli belastet før,
              eller i begynnelsen av, hver abonnementsperiode for
              abonnementsavgiften pluss eventuelle gjeldende skatter og andre
              belastninger. Før vi belaster deg for en abonnementsperiode,
              varsler vi deg om de gjeldende avgiftene, og fornyelsen vil skje
              til prisen som da gjelder for den betalte tjenesten.
            </b>
          </TypographyV3>
          <TypographyV3>
            <b>
              Du kan si opp abonnementet ditt når som helst. Oppsigelsen trer i
              kraft ved slutten av inneværende abonnementsperiode. Ønsker du å
              si opp abonnementet og avbryte den automatiske betalingen, kan du
              klikke på Si opp konto-knappen i kontoskjermbildet eller kontakte
              teamet vårt ved å gå til support.ouraring.com og sende inn en
              henvendelse. Oppsigelse av abonnementet gir deg ikke rett til
              refusjon av tidligere betalte avgifter, og du vil ikke motta noen
              forholdsmessig refusjon for resten av abonnementsperioden.
            </b>{' '}
            Dersom du sier opp abonnementet, må du være oppmerksom på at vi
            fremdeles kan sende deg salgsfremmende kommunikasjon, med mindre du
            velger bort å motta slik kommunikasjon ved å følge
            avmeldingsinstruksjonene du finner i henvendelsene.
          </TypographyV3>
          <TypographyV3>
            {' '}
            <b>
              Når du sier opp et abonnement, avbryter du bare fremtidige
              belastninger for abonnementet. Du vil ikke motta en refusjon for
              den inneværende abonnementsperioden som du har betalt for, men du
              vil fortsatt ha full tilgang til dette abonnementet til utgangen
              av den gjeldende abonnementsperioden.
            </b>{' '}
            Når som helst og uansett årsak kan vi gi refusjon, rabatt eller
            annen kompensasjon («godtgjørelse») til alle eller noen av brukerne
            våre. Beløpet på og formen av slike godtgjørelser, samt beslutningen
            om å gi dem, avgjøres etter eget skjønn. Selv om det gis en
            godtgjørelse i ett tilfelle, gir det deg ikke rett til godtgjørelser
            for lignende tilfeller i fremtiden, og det forplikter oss heller
            ikke til å gi godtgjørelser i fremtiden.
          </TypographyV3>
          <TypographyV3>
            Hvis du bor utenfor USA og ombestemmer deg med hensyn til kjøpet,
            kan du ha rett til å motta full refusjon innen fjorten (14) dager
            («angrerettsperiode»), forutsatt at du ikke har logget på eller på
            annen måte innløst eller begynt å bruke tjenestene som abonnent i
            løpet av angrerettsperioden.
          </TypographyV3>
          <TypographyV3>
            Fra tid til annen kan vi tilby kostnadsfrie prøveperioder av enkelte
            abonnementer i bestemte tidsperioder uten betaling.{' '}
            <b>
              Før du starter den kostnadsfrie prøveperioden, vil vi varsle deg
              om gjeldende abonnementsavgifter som vil bli belastet ved utløpet
              av den kostnadsfrie prøveperioden. Med mindre du sier opp
              abonnementet ditt før slutten av den kostnadsfrie prøveperioden
              ved å følge trinnene som er angitt ovenfor, vil vi eller vår
              tredjeparts betalingsbehandler fakturere deg regelmessig for
              abonnementsavgiften via din angitte betalingsmåte, pluss
              eventuelle gjeldende skatter og andre gebyrer, så lenge
              abonnementet ditt fortsetter. Du må si opp abonnementet før
              slutten av den kostnadsfrie prøveperioden for å unngå kostnader.
              Anvisninger om hvordan du sier opp abonnementet, er gitt ovenfor.
            </b>
          </TypographyV3>
          <TypographyV3>
            Betalingsinformasjonen din vil bli behandlet og lagret via en
            tredjeparts betalingsbehandler. Alle betalende kontoinnehavere må ha
            minst én gyldig betalingsmåte for betaling av avgifter, som er
            beskrevet mer detaljert i kassen. Alle avgifter beregnes og
            faktureres deg på månedlig eller årlig basis, avhengig av hva du
            velger. Avgiftene forfaller umiddelbart ved mottak og kan bli
            endret. Du erkjenner at det benyttes gjentakende betaling av
            avgifter, og du påtar deg ansvaret for alle gjentakende belastninger
            før oppsigelse. Avgifter skal belastes eller debiteres fra den
            lagrede, angitte betalingsmåten som du oppgir, én dag før den datoen
            du opprinnelig kjøpte produktet, enten på månedlig eller årlig
            basis.
          </TypographyV3>
          <TypographyV3>
            Hvis du ikke har logget på eller brukt tjenestene på annen måte på
            seks (6) måneder eller lenger etter kjøp eller mottak av et produkt
            under en kostnadsfri prøveperiode, forbeholder vi oss retten til å
            si opp abonnementet ditt, kansellere eventuelle ventende kjøp og
            refundere kun kjøpesummen for produktet. Du vil ikke ha rett til
            refusjon for verdien av abonnementet under den kostnadsfrie
            prøveperioden.
          </TypographyV3>
          <TypographyV3>
            Oura forbeholder seg retten til når som helst å justere avgiftene
            for de betalte tjenestene våre, eller for hvilke som helst
            funksjoner i eller deler av de betalte tjenestene. Du erkjenner at
            Oura når som helst kan endre avgiftene for de betalte tjenestene.
            Skulle en slik endring finne sted, vil Oura varsle deg via
            e-postadressen som er knyttet til kontoen din, minst tretti (30)
            dager før endringen trer i kraft. Din fortsatte bruk av tjenestene
            indikerer at du godtar eventuelle endringer i avgiftene. Du er ene
            og alene ansvarlig for alle gjeldende skatter, og du vil bli
            belastet for gjeldende skatter når det er lovpålagt.
          </TypographyV3>
          <TypographyV3 Element="h2" variant="h3">
            Data og kommunikasjon
          </TypographyV3>
          <TypographyV3>
            Oura kan samle inn og behandle informasjon om din bruk av
            tjenestene. Du samtykker i Ouras innsamling og bruk av slik
            informasjon, samt i deling av slik informasjon med tredjeparts
            tjenesteleverandører med det formål å tilby, markedsføre og forbedre
            tjenestene, og av enhver annen årsak beskrevet i
            personvernerklæringen. Alle personopplysninger som innhentes av
            Oura, behandles i samsvar med personvernerklæringen.
          </TypographyV3>
          <TypographyV3>
            <b>
              Ved å godta vilkårene og betingelsene i denne avtalen og oppgi
              kontaktinformasjonen din til Oura gir du ditt uttrykkelige
              samtykke til at Oura, dets tilknyttede selskaper og representanter
              kan kontakte deg fra tid til annen på ethvert telefonnummer eller
              enhver postadresse eller e-postadresse som du oppgir til Oura.
            </b>{' '}
            Samtykket ditt betyr at du godtar å bli kontaktet av Oura og deres
            tjenesteleverandører via telefon, e-post, tekstmelding eller på
            andre måter for ethvert formål, inkludert, men ikke begrenset til,
            varsler knyttet til tjenestene og kontoen din, abonnementer, kjøp,
            tilgjengelige oppgraderinger, problemer med fakturering og
            betalingsbehandling, og telefonsalg. Slik tillatt kommunikasjon kan
            omfatte bruk av automatisert oppringingsteknologi eller bruk av
            forhåndsinnspilte meldinger. Du er ansvarlig for eventuelle
            belastninger som kan bli fakturert deg av tjenesteleverandøren(e)
            når vi kontakter deg. Du erkjenner videre at ditt samtykke til det
            foregående ikke er en betingelse for å bruke Oura-tjenestene, og
            hvis du ikke ønsker å samtykke, kan du kontakte oss og be om å bli
            plassert på en «ikke kontakt meg»-liste, eller du kan velge dette
            bort når som helst ved å bruke bortvalgsalternativet som gis i alle
            slike henvendelser.
          </TypographyV3>
          <TypographyV3>
            Oura fraskriver seg alt ansvar i henhold til denne avtalen for all
            informasjon du oppgir til Oura, som kan utgjøre elektroniske
            pasientjournaler eller lignende informasjon gitt av deg eller en
            sluttbruker, uavhengig av eventuelle motstridende bestemmelser i
            denne avtalen eller som på annen måte er pålagt i henhold til
            gjeldende føderale, statlige eller internasjonale lover, regler
            eller forskrifter.
          </TypographyV3>
          <TypographyV3 Element="h2" variant="h3">
            Immaterielle rettigheter
          </TypographyV3>
          <TypographyV3>
            ŌURA, Ō og OURA er varemerker for Ōura Health Oy. Oura-innhold,
            Oura-produkter, Oura-funksjoner og -tjenester og den underliggende
            teknologien er beskyttet av lover om opphavsrett, varemerker,
            patenter, åndsverk og annen lovgivning i USA og andre land. Alle
            rettigheter er forbeholdt. Du gis ikke, verken implisitt eller på
            annen måte, noen lisens eller rett til å bruke merker som vises i,
            eller som brukes eller vises i forbindelse med, tjenestene
            («varemerker»). Tjenestene kan også inneholde eller referere til
            tredjepartsvaremerker, handelsnavn, produktnavn og logoer som kan
            være registrerte varemerker for sine respektive eiere. Du kan ikke
            under noen omstendigheter bruke eller kopiere noen av varemerkene.
            Ingenting i dette dokumentet skal tolkes som å gi noen lisens eller
            rett til å bruke varemerker som vises i forbindelse med tjenestene,
            uten Ouras uttrykkelige skriftlige tillatelse.
          </TypographyV3>
          <TypographyV3>
            Alt innhold som tilbys i forbindelse med tjenestene og denne
            avtalen, inkludert, men ikke begrenset til, nettstedet, produktet,
            mobilappen, alt av tekst, grafikk, brukergrensesnitt, visuelle
            grensesnitt, fotografier, bilder/video, elektronisk kunst,
            lyder/audio, data, kommunikasjonsprogrammer, kjørbar kode, datakode
            og data (samlet kalt «innhold») som er formatert, organisert og
            samlet inn i en rekke ulike former, inkludert design, struktur,
            utvalg, koordinasjon, uttrykk, utseende og preg, arrangement,
            oppsett, sider, skjermbilder og databaser med slikt innhold, som
            finnes i innholdet, tjenestene og underliggende teknologi, og alt
            annet opphavsrettsbeskyttet arbeid knyttet til tjenestene
            («opphavsrettsbeskyttet arbeid»), eies, kontrolleres eller
            lisensieres utelukkende av eller til Oura og beskyttes av lover om
            opphavsrett internasjonalt og i USA. Du samtykker i at du ikke
            direkte eller indirekte vil kopiere, reprodusere, modifisere, lage
            avledede verk fra, distribuere eller offentliggjøre det
            opphavsrettsbeskyttede arbeidet uten å ha fått en uttrykkelig
            skriftlig tillatelse fra Oura på forhånd.
          </TypographyV3>
          <TypographyV3>
            Hvis du formidler meldinger eller materiale til Oura via post,
            e-post, telefon eller på annen måte, hvor du foreslår eller
            anbefaler endringer i tjenestene, inkludert, men ikke begrenset til,
            nye funksjoner eller ny funksjonalitet knyttet til disse, eller
            eventuelle kommentarer, spørsmål, forslag eller lignende
            («tilbakemelding»), står Oura fritt til å bruke slike
            tilbakemeldinger uavhengig av eventuelle andre forpliktelser eller
            begrensninger mellom partene som regulerer slike tilbakemeldinger.
            Oura står fritt til å bruke alt av ideer, kunnskap, konsepter,
            teknikker eller andre immaterielle rettigheter som inngår i
            tilbakemeldingen, for ethvert formål, uten noen tilskrivelse eller
            kompensasjon til noen part. Oura er imidlertid ikke pålagt å benytte
            seg av slik tilbakemelding.
          </TypographyV3>
          <TypographyV3>
            Oura respekterer andres immaterielle rettigheter og har som policy
            at vi raskt skal behandle og gjennomgå varsler om angivelige brudd
            på opphavsrett eller andre gjeldende lover om immaterielle
            rettigheter. Eventuelle varsler om angivelige krenkelser skal sendes
            til Ouras utpekte representant på ip@ouraring.com og må inneholde
            alt av det følgende: (i) en signatur (fysisk eller elektronisk) fra
            opphavsrettseieren eller en person som har myndighet til å handle på
            vegne av opphavsrettseieren, (ii) en beskrivelse av det
            opphavsrettsbeskyttede arbeidet som du hevder har blitt krenket,
            (iii) en beskrivelse av materialet som du hevder er krenkende, og
            som må fjernes, eller hvor tilgangen til dette må deaktiveres, og
            tilstrekkelig informasjon til at Ouras administratorer kan finne
            materialet, (iv) tilstrekkelig informasjon til at vi kan kontakte
            deg, for eksempel adresse, telefonnummer og e-postadresse, (v) en
            erklæring om at du i god tro mener at bruken av materialet på den
            måten det klages på, ikke er tillatt av opphavsrettseieren eller
            vedkommendes representant eller i henhold til gjeldende lov, og (vi)
            en erklæring om at informasjonen i varselet er korrekt og, med
            henvisning til straff for falsk forklaring, at du er
            opphavsrettseieren eller har myndighet til å opptre på vegne av
            eieren av en opphavsrett som angivelig er krenket.
          </TypographyV3>
          <TypographyV3 Element="h2" variant="h3">
            Garantifraskrivelse
          </TypographyV3>
          <TypographyV3>
            TJENESTENE LEVERES TIL DEG «SOM DE ER MED ALLE FEIL» OG «AVHENGIG AV
            TILGJENGELIGHET» UTEN NOEN FORM FOR GARANTI, OG OURA OG DETS
            DATTERSELSKAPER, TILKNYTTEDE SELSKAPER, LEDERE, DIREKTØRER,
            MEDARBEIDERE, REPRESENTANTER, AGENTER, PARTNERE OG LISENSGIVERE
            FRASKRIVER SEG HERVED ALLE GARANTIER OG BETINGELSER MED HENSYN TIL
            TJENESTENE, BÅDE UTTRYKKELIGE OG UNDERFORSTÅTTE, OG FRASKRIVER SEG
            UTTRYKKELIG EVENTUELLE UNDERFORSTÅTTE GARANTIER OM EIENDOMSRETT,
            SALGBARHET, EGNETHET FOR ET BESTEMT FORMÅL, TILFREDSSTILLENDE
            KVALITET OG IKKE-KRENKELSE. OURA GARANTERER IKKE AT DET IKKE KAN
            OPPSTÅ FORSTYRRELSE AV DIN BRUK AV TJENESTENE, TILGJENGELIGHETEN AV
            INNHOLD, AT FUNKSJONENE I TJENESTENE VIL OPPFYLLE DINE KRAV, AT
            TJENESTENE VIL VÆRE FRI FOR VIRUS ELLER ANDRE SKADELIGE KOMPONENTER,
            AT DRIFTEN AV TJENESTENE VIL VÆRE UTEN AVBRUDD ELLER FEILFRI, AT
            FEIL I TJENESTENE VIL BLI RETTET, ELLER AT FUNKSJONENE I TJENESTENE
            VIL FUNGERE MED ANDRE MOBILAPPER ELLER ANNEN MASKINVARE, ELLER I ET
            SYSTEM. INGEN MUNTLIG ELLER SKRIFTLIG INFORMASJON ELLER RÅD SOM GIS
            AV OURA ELLER DETS AUTORISERTE REPRESENTANT, SKAL UTGJØRE EN
            GARANTI. NOEN JURISDIKSJONER TILLATER IKKE UTELUKKELSE AV
            UNDERFORSTÅTTE GARANTIER ELLER BEGRENSNINGER I KUNDENS LOVBESTEMTE
            RETTIGHETER, SÅ DET KAN HENDE AT UTELUKKELSENE OG BEGRENSNIGNENE
            OVENFOR IKKE GJELDER FOR DEG.
          </TypographyV3>
          <TypographyV3>
            UAVHENGIG AV DET FOREGÅENDE GARANTERER OURA OVERFOR DEN OPPRINNELIGE
            SLUTTBRUKERKJØPEREN AT PRODUKTET ER FRITT FOR DEFEKTER I MATERIALE
            OG UTFØRELSE I ETT (1) ÅR FRA KJØPSDATOEN. Hvis lokal lovgivning som
            gjelder på kjøpstidspunktet, pålegger en garantiperiode som er
            lenger enn ett (1) år, skal denne garantien utvides i den grad loven
            krever det. Innenfor garantiperioden skal Oura vederlagsfritt
            reparere eller erstatte eventuelle produktkomponenter som ikke
            oppfyller den begrensede garantien. Du er ansvarlig for eventuelle
            tilknyttede transportkostnader. Erstatningsprodukter kan være nye
            eller renoverte etter vårt skjønn. Denne begrensede garantien
            gjelder ikke for (i) normal slitasje, inkludert riper og bulker,
            (ii) forbruksdeler inkludert i produktet, for eksempel batterier,
            med mindre skaden på produktet har oppstått på grunn av en defekt i
            materiale eller utførelse, (iii) skade som følge av at du ikke
            bruker produktet i samsvar med instruksjonene som fulgte med
            Ōura-produktet eller som er tilgjengelige på nettstedet, (iv) skade
            som følge av en ulykke, flom, brann, feil bruk eller misbruk, (v)
            skade som er et resultat av utført service, eller skade som følge av
            at produktet har blitt tuklet med eller endret, av noen som ikke er
            autorisert av Ōura, eller (vi) bruk av produktet med en annen app
            eller programvare enn mobilappen.
          </TypographyV3>
          <TypographyV3>
            Oura forbeholder seg eneretten til å reparere eller erstatte
            produktet, eller tilby full refusjon, etter eget skjønn. Dette
            rettsmiddelet skal være ditt eneste og eksklusive rettsmiddel for
            ethvert brudd på denne begrensede garantien. Garantireparasjoner og
            -erstatninger har en ny garantiperiode som gjelder i enten nitti
            (90) dager eller for resten av den opprinnelige garantiperioden på
            ett (1) år (det som varer lengst).
          </TypographyV3>
          <TypographyV3 Element="h2" variant="h3">
            Ansvarsbegrensning
          </TypographyV3>
          <TypographyV3>
            IKKE UNDER NOEN OMSTENDIGHETER VIL OURA, DETS DATTERSELSKAPER,
            TILKNYTTEDE SELSKAPER, LEDERE, DIREKTØRER, MEDARBEIDERE,
            REPRESENTANTER, AGENTER, PARTNERE OG LISENSGIVERE VÆRE ANSVARLIGE
            FOR SKADER AV NOE SLAG, I HENHOLD TIL NOEN RETTSTEORI, SOM OPPSTÅR
            GJENNOM ELLER I FORBINDELSE MED DIN BRUK, ELLER MANGLENDE EVNE TIL Å
            BRUKE, TJENESTENE ELLER NOE AV INNHOLDET KNYTTET TIL TJENESTENE,
            ELLER ANDRE SLIKE NETTSTEDER ELLER TJENESTER ELLER ELEMENTER SOM DET
            GIS TILGANG TIL GJENNOM TJENESTENE, INKLUDERT DIREKTE, INDIREKTE,
            SPESIELLE ELLER TILFELDIGE FØLGESKADER ELLER
            STRAFFEERSTATNINGSSKADER, INKLUDERT, MEN IKKE BEGRENSET TIL,
            PERSONSKADE, SMERTE OG LIDELSE, FØLELSESMESSIG PÅKJENNING, TAP AV
            INNTEKTER, TAP AV FORTJENESTE, TAPTE FORRETNINGSMULIGHETER ELLER
            FORVENTET BESPARELSE, FORRETNINGSAVBRUDD, TAP AV BRUK, TAP AV
            GOODWILL, TAP AV DATA OG, ENTEN DET SKYLDES RETTSSTRIDIGE FORHOLD
            (INKLUDERT UAKTSOMHET), BRUDD PÅ KONTRAKT ELLER ANNET, SELV OM DET
            KUNNE FORUTSES. DISSE UNNTAKENE ELLER BEGRENSNINGENE GJELDER
            UAVHENGIG AV OM OURA HAR BLITT ADVART ELLER IKKE OM MULIGHETEN FOR
            AT SLIKE SKADER KAN OPPSTÅ.
          </TypographyV3>
          <TypographyV3>
            DET OVENNEVNTE PÅVIRKER IKKE ANSVAR SOM IFØLGE GJELDENDE LOV IKKE
            KAN EKSKLUDERES ELLER BEGRENSES. I DEN GRAD ANSVAR IKKE KAN
            UTELUKKES ELLER BEGRENSES SOM ANGITT OVENFOR, SKAL OURA IKKE UNDER
            NOEN OMSTENDIGHETER HOLDES ANSVARLIG FOR NOE KRAV, VERKEN I HENHOLD
            TIL KONTRAKT, ERSTATNINGSRETTSLIGE FORHOLD ELLER NOEN ANNEN TEORI OM
            ANSVAR, SOM OVERSTIGER USD 100.
          </TypographyV3>
          <TypographyV3 Element="h2" variant="h3">
            Forholdsregler
          </TypographyV3>
          <TypographyV3>
            TJENESTENE ER IKKE MEDISINSK UTSTYR, OG DU SAMTYKKER UTTRYKKELIG I
            AT TJENESTENE IKKE INNEBÆRER MEDISINSK RÅDGIVNING FRA OURA.
            TJENESTENE ER IKKE MENT FOR Å DIAGNOSTISERE, BEHANDLE, HELBREDE
            ELLER FORHINDRE NOEN SYKDOM ELLER MEDISINSK TILSTAND. TJENESTENE ER
            KUN TIL INFORMASJONSFORMÅL OG KAN IKKE ERSTATTE TJENESTENE TIL LEGER
            ELLER MEDISINSK FAGPERSONELL.
          </TypographyV3>
          <TypographyV3>
            TJENESTENE, INKLUDERT ALT AV INFORMASJON, TEKST, FOTOGRAFIER,
            BILDER, ILLUSTRASJONER, GRAFIKK, LYD, VIDEO OG VIDEOKLIPP MED LYD,
            SAMT ANNET MATERIALE, ENTEN DET ER LEVERT AV OSS ELLER AV
            TREDJEPARTER, ER IKKE MENT Å VÆRE OG SKAL IKKE BRUKES I STEDET FOR
            (a) RÅDGIVNING FRA LEGEN DIN ELLER ANNET HELSEPERSONELL, (b) BESØK,
            SAMTALER ELLER KONSULTASJONER MED LEGEN DIN ELLER ANNET
            HELSEPERSONELL, ELLER (c) INFORMASJON SOM FINNES I ELLER PÅ NOEN
            PRODUKTEMBALLASJE ELLER PRODUKTMERKING.
          </TypographyV3>
          <TypographyV3>
            DERSOM DU HAR HELSERELATERTE SPØRSMÅL, MÅ DU KONTAKTE LEGEN DIN
            ELLER ANNET HELSEPERSONELL SNAREST. SKULLE DET OPPSTÅ EN
            NØDSITUASJON, MÅ DU RINGE LEGEN DIN ELLER 113 UMIDDELBART. DU BØR
            ALDRI IGNORERE MEDISINSKE RÅD ELLER VENTE MED Å SØKE MEDISINSK
            RÅDGIVNING PÅ BAKGRUNN AV INFORMASJON DU FINNER I TJENESTENE, OG DU
            SKAL IKKE BRUKE TJENESTENE ELLER INFORMASJON SOM TILBYS I
            TJENESTENE, TIL Å DIAGNOSTISERE ELLER BEHANDLE ET HELSEPROBLEM.
            OVERFØRING OG MOTTAK AV TJENESTER, HELT ELLER DELVIS, ELLER
            KOMMUNIKASJON VIA INTERNETT, E-POST ELLER ANDRE MIDLER, UTGJØR IKKE
            ELLER SKAPER IKKE ET LEGE/PASIENT-FORHOLD, BEHANDLER/PASIENT-FORHOLD
            ELLER FORHOLD TIL ANNET HELSEPERSONELL MELLOM DEG OG OURA.
          </TypographyV3>
          <TypographyV3>
            Du bør alltid rådføre deg med en lege før du gjør endringer knyttet
            til søvn eller aktiviteter basert på informasjon du mottar via
            tjenestene, eller hvis du har spørsmål angående en medisinsk
            tilstand. Oura er ikke ansvarlig for eventuelle helseproblemer som
            kan oppstå som følge av informasjon du tilegner deg gjennom
            tjenestene. Hvis du gjør noen endringer knyttet til søvn eller
            aktiviteter basert på tjenestene, samtykker du i at du gjør dette på
            egen risiko. Det er viktig å følge med på kroppens reaksjoner. Hvis
            du for eksempel føler en uventet, gjentagende eller langvarig
            smerte, eller utmattelse eller ubehag som følge av at du har gjort
            endringer knyttet til søvn eller aktiviteter, anbefales det at du
            rådfører deg med en lege før du fortsetter med slike endringer.
            Informasjonen i tjenestene kan være misvisende hvis de fysiologiske
            funksjonene og reaksjonene dine avviker vesentlig fra gjennomsnittet
            av befolkningen på grunn av en medisinsk tilstand eller sjeldne
            naturlige forskjeller.
          </TypographyV3>
          <TypographyV3>
            Vær forsiktig så ikke produktet du har på deg, setter seg fast i
            faste innretninger eller tunge gjenstander. Dersom du opplever
            rødhet eller hudirritasjon på fingeren når du bruker produktet, må
            du ta det av deg umiddelbart. Dersom symptomene vedvarer lenger enn
            2–3 dager etter at du har tatt produktet av fingeren, må du kontakte
            helsepersonell.
          </TypographyV3>
          <TypographyV3>
            Produktet vårt må ikke på noe tidspunkt puttes i munnen. Ouras
            produkt er ikke et leketøy, og det er heller ikke beregnet på å
            brukes av barn. Oppbevar produktet utilgjengelig for barn, da det
            kan utgjøre en kvelningsfare.
          </TypographyV3>
          <TypographyV3>
            Tjenestene kan inneholde lenker til andre nettsteder som drives av
            tredjeparter. Du erkjenner og godtar at slike lenker kun er gitt til
            deg som en bekvemmelighet, og at det ikke innebærer at Oura støtter,
            har en tilknytning eller relasjon til eller sponser leverandøren av
            et slikt lenket nettsted eller kvaliteten, påliteligheten eller
            andre kjennetegn eller egenskaper ved slike lenkede nettsteder. Du
            erkjenner og godtar videre at Oura ikke på noen måte er ansvarlig
            (inkludert, men ikke begrenset til, ethvert tap eller enhver skade
            som du kan bli utsatt for) for noe forhold knyttet til det lenkede
            nettstedet, inkludert, men ikke begrenset til, innholdet som tilbys
            på eller gjennom et slikt lenket nettsted eller din tillit til det.
            Vær også oppmerksom på at din bruk av tredjeparters nettsteder er
            underlagt vilkårene og betingelsene som gjelder for det aktuelle
            nettstedet, inkludert personvernerklæringene (eller mangelen på
            disse) for nettstedet. Hvis en tredjepart lenker til tjenestene, er
            det ikke nødvendigvis en indikasjon på de er støttet av, har en
            tilknytning til eller en relasjon med eller sponser eller blir
            sponset av Oura. Oura er kanskje ikke engang klar over at en
            tredjepart har lenket til tjenestene.
          </TypographyV3>
          <TypographyV3>
            Alt annet innhold som ikke eies av Oura, er eid av sin respektive
            eier. Du erkjenner og godtar at slikt innhold leveres av eieren og
            ikke innebærer at Oura støtter, har en tilknytning eller relasjon
            til eller sponser leverandøren av slikt innhold. Du erkjenner og
            godtar videre at Oura ikke på noen måte er ansvarlig (inkludert, men
            ikke begrenset til, ethvert tap eller enhver skade som du kan bli
            utsatt for) for hvilket som helst innhold som leveres av
            tredjeparter, inkludert, men ikke begrenset til, din tillit til det.
            OURA GIR INGEN ERKLÆRINGER ELLER GARANTIER MED HENSYN TIL NOE
            TREDJEPARTSINNHOLD.
          </TypographyV3>
          <TypographyV3>
            Du godtar å holde Oura, dets datterselskaper, tilknyttede selskaper,
            ledere, direktører, medarbeidere, representanter, agenter, partnere,
            lisensgivere, etterfølgere og overdragere skadesløse, og beskytte
            dem fra og mot enhver form for søksmål, sak, krav, skadeserstatning,
            gjeld, begjæring eller ansvar, inkludert rimelige kostnader og
            advokathonorarer, fremsatt av enhver person, som oppstår som følge
            av eller i forbindelse med (i) din bruk av tjenestene, inkludert,
            men ikke begrenset til, at noen bruker kontoen eller
            påloggingsinformasjonen din, (ii) at du eller noen som bruker
            kontoen eller påloggingsinformasjonen din, bryter denne avtalen,
            (iii) all informasjon som brukes, lagres eller overføres i
            forbindelse med kontoen eller påloggingsinformasjonen din, (iv) at
            du eller noen som bruker kontoen eller påloggingsinformasjonen din,
            bryter rettighetene til en tredjepart, herunder inkludert, men ikke
            begrenset til, personvern, offentlig omtale, åndsverk eller annen
            eiendomsrett, eller (v) brudd på lover, forskrifter eller andre
            lovfestede krav.
          </TypographyV3>
          <TypographyV3 Element="h2" variant="h3">
            Merknad for brukere i California
          </TypographyV3>
          <TypographyV3>
            I henhold til California Civil Code Section 1789.3 skal følgende
            merknad om spesifikke forbrukerrettigheter oppgis til brukere av
            tjenestene i California:
          </TypographyV3>
          <TypographyV3>
            Complaint Assistance Unit ved Division of Consumer Services i
            California Department of Consumer Affairs kan kontaktes skriftlig på
            1625 N. Market Blvd., Suite N 112, Sacramento, California 95834,
            USA, eller på telefonnummeret (800) 952-5210.
          </TypographyV3>
          <TypographyV3 Element="h2" variant="h3">
            Oppsigelse; Kansellering
          </TypographyV3>
          <TypographyV3>
            Denne avtalen skal gjelde i sin helhet til den sies opp eller
            kanselleres i henhold til denne avtalen.
          </TypographyV3>
          <TypographyV3>
            Oura skal ha rett til å si opp denne avtalen (i) uansett årsak ved å
            gi deg tretti (30) dagers varsel, (ii) umiddelbart ved vesentlig
            mislighold av denne avtalen fra din side, annet enn manglende
            betaling av avgifter, eller (iii) for manglende betaling av
            avgifter. Uavhengig av det foregående forbeholder Oura seg retten
            til, etter eget skjønn og uten varsel, når som helst og av hvilken
            som helst årsak, å fjerne, endre, sperre eller deaktivere tilgang
            til alle eller en hvilken som helst del av tjenestene.
          </TypographyV3>
          <TypographyV3>
            Du kan si opp avtalen av hvilken som helst årsak ved å gi tretti
            (30) dagers varsel til Oura ved å gå til support.ouraring.com og
            sende inn en henvendelse. Du er ansvarlig for alle avgifter som
            påløper før og under oppsigelsesperioden.
          </TypographyV3>
          <TypographyV3>
            Avsnittene Forholdsregler, Immaterielle rettigheter, Data og
            kommunikasjon, Erstatning, Garantifraskrivelse, Ansvarsbegrensning,
            Gjeldende lov, Forum, Obligatorisk bindende voldgift og Fraskrivelse
            av gruppesøksmål samt forpliktelser til å betale avgifter som
            påløper før og under enhver oppsigelsesperiode, skal gjelde også
            etter oppsigelse av denne avtalen, uansett årsak.
          </TypographyV3>
          <TypographyV3>
            Sluttbruksbegrensninger for føderale myndigheter
          </TypographyV3>
          <TypographyV3>
            Hvis du er et departement eller et organ for føderale myndigheter i
            USA, eller inngår kontrakt på vegne av et slikt departement eller
            organ, er tjenestene «kommersielle varer» slik dette begrepet er
            definert i 48 C.F.R. § 2.101, bestående av «kommersiell programvare»
            og «dokumentasjon for kommersiell programvare», slik disse begrepene
            blir brukt i 48 C.F.R. § 12.212 eller 48 C.F.R. § 227.7202. I
            samsvar med 48 C.F.R. § 12.212 eller 48 C.F.R. § 227.7202-1 til
            227.7202-4, avhengig av hva som er aktuelt, er tjenesten lisensiert
            til deg kun med de rettighetene som er angitt i vilkårene og
            betingelsene i denne avtalen. Hvis du er en innkjøpsaktivitet for
            føderale myndigheter i USA, eller er ansatt i en virksomhet som
            gjennomfører innkjøpsaktivitet gjennom en GSA Schedule-kontrakt i
            din egenskap av å være en agent for slik innkjøpsaktivitet, kan
            vilkårene i denne publiserte avtalen og personvernerklæringen
            variere
          </TypographyV3>
          <TypographyV3>
            Overholdelse av eksportlover og bruksbegrensninger
          </TypographyV3>
          <TypographyV3>
            Du vil ikke direkte eller indirekte eksportere eller reeksportere
            tjenestene, eller noen teknisk informasjon knyttet til disse, til
            noen destinasjon eller person som det etter gjeldende lovgivning,
            inkludert, men ikke begrenset til, alle gjeldende lover og
            forskrifter om eksportkontroll i USA, er forbudt å eksportere til
            eller begrensninger på eksporten til.
          </TypographyV3>
          <TypographyV3>
            Gjeldende lov; Forum; Obligatorisk bindende voldgift, Fraskrivelse
            av gruppesøksmål
          </TypographyV3>
          <TypographyV3>
            Enhver handling knyttet til denne avtalen, tjenestene og forholdet
            ditt til Oura skal reguleres av, fortolkes og tolkes i samsvar med
            lovene i delstaten California uten hensyn til prinsippene om
            lovkonflikter, OG VIL SPESIFIKT IKKE VÆRE UNDERLAGT FN-KONVENSJONENE
            OM KONTRAKTER FOR INTERNASJONALT SALG AV VARER, HVIS GJELDENDE
            ELLERS. Du samtykker i å løse eventuelle tvister eller krav som
            oppstår som følge av eller i tilknytning til denne avtalen eller
            tjenestene, gjennom endelig og bindende voldgift av en enkelt
            voldgiftsdommer. Dette omfatter også tvister som oppstår som følge
            av eller i forbindelse med tolkning eller anvendelse av avsnittet
            «Obligatorisk bindende voldgift», inkludert dets håndhevbarhet,
            mulighet for tilbakekalling eller gyldighet. Uavhengig av det
            foregående kan hver av partene reise søksmål utelukkende for
            rettslig påbud om å stoppe uautorisert bruk eller misbruk av
            tjenestene, eller krenkelse av immaterielle rettigheter. Underlagt
            bestemmelsen om obligatorisk bindende voldgift samtykker partene
            ugjenkallelig i å reise søksmål for å løse eller håndheve krav som
            oppstår som følge av eller i tilknytning til denne avtalen i de
            føderale eller delstatlige domstolene i San Francisco, California,
            USA, og hver part underkaster seg ugjenkallelig den eksklusive
            jurisdiksjonen til slike domstoler i slike søksmål eller rettssaker.
            Bortsett fra i den grad det er forbudt i henhold til gjeldende lov,
            er partene enige om at ethvert krav eller søksmål som oppstår som
            følge av eller i tilknytning til bruk av tjenestene eller denne
            avtalen, må fremsettes innen ett (1) år etter at et slikt krav eller
            søksmålsgrunnlag oppsto, eller utelukkes for alltid. Dette avsnittet
            gjelder ikke for brukere som er bosatt i EU. Hvis du er en bruker
            med tilhold i EU, skal finsk lov gjelde for denne avtalen, og finske
            domstoler skal ha enejurisdiksjon til å behandle tvister som oppstår
            i forbindelse med denne avtalen. Denne bestemmelsen skal ikke gjelde
            for forbrukere i land som krever at avtaler skal reguleres av lokal
            lovgivning i landet til forbrukeren. Det engelske språket skal ha
            forrang i alle dokumenter, merknader og tolkninger av denne avtalen.
            Du samtykker også i å frafalle enhver rett til å fremsette krav mot
            Oura som representant eller medlem i ethvert gruppe- eller
            representantsøksmål, bortsett fra der slik fraskrivelse er forbudt
            ved lov eller anses av en domstol å være i strid med allmenne
            interesser.
          </TypographyV3>
          <TypographyV3 Element="h2" variant="h3">
            Diverse
          </TypographyV3>
          <TypographyV3>
            Du bekrefter at Oura har rett til å overvåke bruken av tjenestene
            for å sikre at avtalen overholdes.
          </TypographyV3>
          <TypographyV3>
            Ingen fraskrivelse av noe vilkår, noen bestemmelse eller noen
            betingelse i denne avtalen, verken gjennom handlinger eller på annen
            måte, i ett eller flere tilfeller, skal anses å være, eller skal
            utgjøre, en fraskrivelse av et annet vilkår eller en annen
            bestemmelse eller betingelse heri, uansett om de er like eller ikke,
            og en slik fraskrivelse skal heller ikke utgjøre en vedvarende
            fraskrivelse av slike vilkår, bestemmelser eller betingelser heri.
            Ingen fraskrivelse skal være bindende med mindre den er gjennomført
            skriftlig av parten som gir fraskrivelsen.
          </TypographyV3>
          <TypographyV3>
            Du kan ikke overdra denne avtalen til noen annen part, og ethvert
            forsøk på å gjøre dette er ugyldig.
          </TypographyV3>
          <TypographyV3>
            Hvis det fastslås at en bestemmelse i denne avtalen er ulovlig eller
            ikke kan håndheves, vil denne bestemmelsen håndheves så langt det er
            mulig, og de andre bestemmelsene vil fortsatt være gyldige og
            håndhevbare.
          </TypographyV3>
          <TypographyV3>
            Denne avtalen og personvernerklæringen utgjør den fullstendige og
            eneste erklæringen om avtalen mellom deg og Oura angående
            tjenestene, og erstatter enhver tidligere eller samtidig
            kommunikasjon, bekreftelser, erklæringer og overenskomster, muntlig
            eller skriftlig, mellom partene.
          </TypographyV3>
          <TypographyV3>
            Hvis det skulle oppstå en konflikt mellom vilkårene i denne avtalen
            og vilkårene i personvernerklæringen, skal vilkårene i denne avtalen
            gjelde.
          </TypographyV3>
          <TypographyV3 Element="h2" variant="h3">
            Endring av vilkårene og tjenestene
          </TypographyV3>
          <TypographyV3>
            Oura forbeholder seg retten til å oppdatere denne avtalen og/eller
            personvernerklæringen når som helst og av hvilken som helst årsak
            etter eget skjønn ved å publisere oppdaterte vilkår. Med mindre Oura
            har angitt noe annet, vil eventuelle endringer tre i kraft etter
            publiseringsdatoen. Oura vil varsle deg om eventuelle vesentlige
            endringer i avtalen eller tjenestene. Ved å fortsette å få tilgang
            til eller bruke tjenestene etter at vi har gitt deg varsel om en
            endring, godtar du å være bundet av den endrede avtalen. Hvis den
            endrede avtalen ikke er akseptabel for deg, er din eneste mulighet å
            slutte å bruke tjenestene. Oura og dets tredjeparts
            tjenesteleverandører kan gjøre forbedringer og/eller endringer i de
            oppgitte tjenestene, funksjonene og prisene når som helst og av
            hvilken som helst årsak etter eget skjønn. Mobilappen kan laste ned
            og installere oppgraderinger, oppdateringer og tilleggsfunksjoner
            for å forbedre, forsterke og videreutvikle tjenestene. Oura
            forbeholder seg retten til når som helst å endre eller avvikle
            tjenestene eller hvilken som helst del av disse, midlertidig eller
            permanent, med eller uten varsel. Du samtykker i at Oura ikke skal
            være ansvarlig overfor deg eller noen tredjepart for en eventuell
            endring, sperring eller avvikling av tjenestene.
          </TypographyV3>
          <TypographyV3 Element="h2" variant="h3">
            ŌURAs LEVERINGSBETINGELSER
          </TypographyV3>
          <TypographyV3>
            <em>Sist oppdatert: 4. mars 2024</em>
          </TypographyV3>
          <TypographyV3 Element="h2" variant="h3">
            Canada og Storbritannia
          </TypographyV3>
          <TypographyV3>
            Oura leverer produktene i henhold til DDP (Delivered Duty Paid)
            Incoterm. Oura er ansvarlig for import og levering av produktene til
            bestemmelsesstedet i kjøperens land. Oura er ansvarlig for å betale
            alle kostnader knyttet til importen av produktene til kjøperens land
            og vil belaste skatter etter gjeldende sats basert på
            leveringsadressen for produktene. Oura utsteder en forskriftsmessig
            faktura med skatter for eventuelle lokale indirekte skatter som
            påløper for salget, i henhold til lokal lovgivning.
          </TypographyV3>
          <TypographyV3 Element="h2" variant="h3">
            EU og USA
          </TypographyV3>
          <TypographyV3>
            Oura vil levere produkter fra lokale distribusjonssentre til
            bestemmelsesstedet i kjøperens respektive jurisdiksjon. Oura vil
            kreve inn skatter etter gjeldende sats basert på leveringsadressen
            for produktene i samsvar med lokalt regelverk.
          </TypographyV3>
          <TypographyV3>
            I andre land enn de som er oppført ovenfor
          </TypographyV3>
          <TypographyV3>
            Oura leverer produktene i henhold til DAP Incoterm med overdragelse
            av eiendomsrett til kjøperen umiddelbart før import. Oura betaler
            for transporten til det navngitte stedet utenfor landet til
            kjøperen, men er ikke ansvarlig for å importere produktene inn i
            landet til kjøperen og levere produktene på bestemmelsesstedet i
            landet til kjøperen. Kjøperen er ansvarlig for alle kostnader
            knyttet til importen av produktene. Oura vil ikke legge til rette
            for innkreving av eventuelle skatter på kjøpers vegne.
          </TypographyV3>
          <TypographyV3>
            Ved en eventuell konflikt mellom den engelskspråklige versjonen og
            oversettelser til andre språk, har det engelske språket forrang, med
            mindre og med unntak av det som kreves i henhold til gjeldende lokal
            lovgivning.
          </TypographyV3>
        </TypographyRhythm>
      </LayoutGrid>
    </PageLayoutV3>
  );
};

export default Page;
